import { render, staticRenderFns } from "./DataciteFooter.vue?vue&type=template&id=3a6492d0&scoped=true&shadow"
import script from "./DataciteFooter.vue?vue&type=script&lang=js&shadow"
export * from "./DataciteFooter.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./DataciteFooter.vue?vue&type=style&index=0&id=3a6492d0&scoped=true&lang=css&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3a6492d0",
  null
  ,true
)

export default component.exports